import {
  GET_MOSQUE_REQUESTS,
  GET_MOSQUE_REQUESTS_REQUEST_ERROR,
  GET_MOSQUE_REQUESTS_REQUEST_PENDING,
  GET_MOSQUE_REQUESTS_REQUEST_SUCCESS,
  GET_MOSQUE_REQUEST_BY_ID,
  UPDATE_MOSQUE_REQUEST_STATUS,
  UPDATE_MOSQUE_REQUEST_STATUS_PENDING,
  UPDATE_MOSQUE_REQUEST_STATUS_SUCCESS,
  UPDATE_MOSQUE_REQUEST_STATUS_ERROR,
} from '../types/mosqueRequests'

const initialState = {
  items: [],
  pagination: {
    current: 1,
    pageSize: 20,
  },
  item: {},
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const mosqueRequests = (state = initialState, action) => {
  switch (action.type) {
    case GET_MOSQUE_REQUESTS:
      return { ...state, ...action.payload }
    case GET_MOSQUE_REQUEST_BY_ID:
      return { ...state, item: action.payload }
    case GET_MOSQUE_REQUESTS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    case GET_MOSQUE_REQUESTS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    case GET_MOSQUE_REQUESTS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    case UPDATE_MOSQUE_REQUEST_STATUS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload.id ? { ...item, status: action.payload.status } : item
        ),
      }
    case UPDATE_MOSQUE_REQUEST_STATUS_PENDING:
      return { ...state, isChangeLoading: true }
    case UPDATE_MOSQUE_REQUEST_STATUS_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }
    case UPDATE_MOSQUE_REQUEST_STATUS_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }
    default:
      return state
  }
}

export default mosqueRequests

